import {omneticApi} from '@dms/api/base';
import {GetBusinessInfoApiArg, GetBusinessInfoApiResponse} from '@dms/api/shared';

export const aresApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getBusinessInfo: build.query<GetBusinessInfoApiResponse, GetBusinessInfoApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/ares/business-info/${queryArg.businessId}`,
        params: {countryCode: queryArg.countryCode},
      }),
    }),
  }),
});

export const {useGetBusinessInfoQuery, useLazyGetBusinessInfoQuery} = aresApi;
